import React, { useState } from 'react';
import { API_BASE_URL } from '../config/api';
import { openAndSaveInvoice } from '../utils/openAndSaveInvoice';
import axios from 'axios';
import withAuthorization from "../components/authentication";
import Navbar from '../components/Navbar';
const SellDealForm = () => {
  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const [formData, setFormData] = useState({
    totalAmountGotTillNowExcludingToken: '',
    amountPaidToSatish: '',
    amountPaidToSatishBy: 'not applicable',
    amountPaidToPiyush: '',
    amountPaidToCompanyAccount: '',
    amountPaidToPiyushBy: 'not applicable',
    amountPaidToOmprakash: '',
    amountPaidToOmprakashBy: 'not applicable',
    CustomerPaymentMode: 'cash',
    tokenAmount: '',
    tokenAmountPaidTo: 'piyush',
    dealAmount: '',
    anyFinalDiscountFromDealAmount: '',
    holdFromCustomer: '',
    RtoCharge:'',
    amountComeFromLoan: '',
    totalAmountGotFromCustomerTillNowIncludingToken: '',
    loanamountstatus:'Not Applicable',
    carTitle: '',
    carRegistrationNumber: '',
    customerWhatsappNumber: '',
    customerMobileNumber: '',
    customerEmail:'',
    customerName: '',
    customerAddress: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };






 // function numberToWordsIndian(num) {


    const numberToWordsIndian = (num) => {
      if (num === 0) return "ZERO"; // Explicitly handle 0 case
    
      const belowTwenty = [
        "Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
        "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
      ];
    
      const tens = [
        "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
      ];
    
      const placeValues = ["", "Thousand", "Lakh", "Crore"];
    
      let parts = []; // Store number parts in words
      let place = 0;  // Index to track Thousand, Lakh, Crore
    
      while (num > 0) {
        let chunk;
        if (place === 0) {
          // First chunk is three digits
          chunk = num % 1000;
          num = Math.floor(num / 1000);
        } else {
          // After first chunk, all others are two digits
          chunk = num % 100;
          num = Math.floor(num / 100);
        }
    
        if (chunk > 0) {
          const words = convertChunk(chunk, belowTwenty, tens);
          parts.unshift(words + (placeValues[place] ? " " + placeValues[place] : ""));
        }
        place++;
      }
    
      return parts.length > 0 ? parts.join(" ").trim().toUpperCase() : "ZERO";
    }
    
    
  
  function convertChunk(num, belowTwenty, tens) {
    if (num < 20) return belowTwenty[num];
    if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? " " + belowTwenty[num % 10] : "");
    return belowTwenty[Math.floor(num / 100)] + " Hundred" + (num % 100 !== 0 ? " " + convertChunk(num % 100, belowTwenty, tens) : "");
  }













  const [loading, setLoading] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    
    
    
    try {
      // Send ONLY JSON. The backend reserves the invoice number, generates the PDF and returns its link.
      const response = await axios.post(`${API_BASE_URL}/deal/create`, formData, { withCredentials: true });

      // Open the invoice in a new tab and save a copy to disk
      openAndSaveInvoice(response.data);

      // Notify the user
      setSubmissionSuccess(true);
  
      // Optionally, reset the form
     
    } catch (error) {
      console.error('Error submitting Deal form:', error);
      alert('Failed to submit the deal form. Please try again.');
    }
   finally {
      setLoading(false); // Set loading to false after submission completes
     }
 };
  








//const totalamountreceived = Number(formData.totalAmountGotTillNowExcludingToken) + Number(formData.tokenAmount);

formData.totalAmountGotFromCustomerTillNowIncludingToken = Number(formData.totalAmountGotTillNowExcludingToken) + Number(formData.tokenAmount);
formData.holdFromCustomer = Number(formData.dealAmount)-Number(formData.anyFinalDiscountFromDealAmount)-Number(formData.amountComeFromLoan)-Number(formData.totalAmountGotTillNowExcludingToken) - Number(formData.tokenAmount);
  return (
    <div><Navbar/><div className="max-w-4xl mx-auto p-6 bg-white  shadow-lg rounded-lg ">
    <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">Sell Deal Form</h1>
    <h1 className="text-1xl font-bold text-gray-900 mb-6">Note:  Do not Consider any RTO Charges in your Mind while filling this form. This form is only for Deal Amount Details</h1>
    <form onSubmit={handleSubmit} className="space-y-6 ">
      <div className="grid grid-cols-1 sm:grid-cols-1 gap-0 ">
        <div className="relative w-full p-4 border border-red-700 rounded ">
        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
            Total Amount Received <strong className="font-bold text-black">Excluding</strong> Token
          </label>
          <input
            type="number"
            name="totalAmountGotTillNowExcludingToken"
            value={formData.totalAmountGotTillNowExcludingToken}
            onChange={handleChange}
            className="border rounded p-2 mb-3"
          />
        </div>
        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
             Total Amount Received <strong>Excluding</strong> Token <strong>in Words</strong>
          </label>
          <input
            type="text"
            name="totalAmountGotTillNowExcludingToken"
            value={ numberToWordsIndian(`${formData.totalAmountGotTillNowExcludingToken}`)}
            
            className="border rounded p-2 mb-3"
            required
          />
        </div>
       
        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
            Amount Paid to Satish
          </label>
          <input
            type="number"
            name="amountPaidToSatish"
            value={formData.amountPaidToSatish}
            onChange={handleChange}
            className="border rounded p-2 mb-3"
            required
          />
        </div>

        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
            Amount Paid to Satish By
          </label>
          <select
            name="amountPaidToSatishBy"
            value={formData.amountPaidToSatishBy}
            onChange={handleChange}
            className="border rounded p-2 bg-white mb-3"
            required
            
          >
            <option value="cash">Cash</option>
            <option value="inpersonalaccount">In Personal Account</option>
            <option value="inpersonalaccount+cash">In Personal Account + Cash</option>
            <option value="Does not Know">Does not Know</option>
            <option value="not applicable">Not Applicable</option>
          </select>
        </div>

        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
            Amount Paid to Piyush
          </label>
          <input
            type="number"
            name="amountPaidToPiyush"
            value={formData.amountPaidToPiyush}
            onChange={handleChange}
            className="border rounded p-2 mb-3"
            required
          />
        </div>
        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
            Amount Paid to Piyush By
          </label>
          <select
            name="amountPaidToPiyushBy"
            value={formData.amountPaidToPiyushBy}
            onChange={handleChange}
            className="border rounded p-2 bg-white bg-3"
            required
          >
            <option value="cash">Cash</option>
            <option value="inpersonalaccount">In Personal Account</option>
            <option value="inpersonalaccount+cash">In Personal Account + Cash</option>
            <option value="Does not Know">Does not Know</option>
            <option value="not applicable">Not Applicable</option>
          </select>
        </div>
        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mt-4">
            Amount Paid to Company Account
          </label>
          <input
            type="number"
            name="amountPaidToCompanyAccount"
            value={formData.amountPaidToCompanyAccount}
            onChange={handleChange}
            className="border rounded p-2 bg-3"
            required
          />
        </div>
        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mt-4">
            Amount Paid to Ompraksh
          </label>
          <input
            type="number"
            name="amountPaidToOmprakash"
            value={formData.amountPaidToOmprakash}
            onChange={handleChange}
            className="border rounded p-2 bg-3"
            required
          />
        </div>
        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mt-4">
            Amount Paid to Omprakash By
          </label>
          <select
            name="amountPaidToOmprakashBy"
            value={formData.amountPaidToOmprakashBy}
            onChange={handleChange}
            className="border rounded p-2 bg-white mt-2"
            required
          >
            <option value="cash">Cash</option>
            <option value="inpersonalaccount">In Personal Account</option>
            <option value="inpersonalaccount+cash">In Personal Account + Cash</option>
            <option value="Does not Know">Does not Know</option>
            <option value="not applicable">Not Applicable</option>
          </select>
        </div>
        

        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mt-4">
            Customer Payment Mode
          </label>
          <select
            name="CustomerPaymentMode"
            value={formData.CustomerPaymentMode}
            onChange={handleChange}
            className="border rounded p-2 bg-white mt-2"
            required
          >
            <option value="cash">Cash</option>
            <option value="In Account">In Account</option>
            <option value="Cash+In Account">In Account + Cash</option>
            
          </select>
        </div>
        </div>
        
        <div className="relative w-full p-4 border border-green-700 rounded ">
        <div className="flex flex-col ">
          <label className="text-gray-700 font-medium mb-3">
            Token Amount Received
          </label>
          <input
            type="number"
            name="tokenAmount"
            value={formData.tokenAmount}
            onChange={handleChange}
            className="border rounded p-2 mb-3"
            required
          />
        </div>
        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-3">
            Token Amount Received <strong>in Words</strong>
          </label>
          <input
            type="text"
            name="tokenAmountinwords"
            value={numberToWordsIndian(`${formData.tokenAmount}`)}
           
            className="border rounded p-2 mb-3"
            required
          />
        </div>


        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-3">
            Token Amount Paid to
          </label>
          <select
            name="tokenAmountPaidTo"
            value={formData.tokenAmountPaidTo}
            onChange={handleChange}
            className="border rounded p-2 bg-white mb-3"
            required
          >
            <option value="piyush">Piyush</option>
            <option value="omprakash">Omprakash</option>
            <option value="satish">Satish</option>
            <option value="InCompany">In Company</option>
            
            
          </select>
        </div>
        {/* Add more fields in the same pattern here */}




        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
            Deal done Amount
          </label>
          <input
            type="number"
            name="dealAmount"
            value={formData.dealAmount}
            onChange={handleChange}
            className="border rounded p-2 mb-3"
            required
          />
        </div>
        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
             Deal done Amount <strong>in Words</strong>
          </label>
          <input
            type="text"
            name="totalAmountGotTillNowExcludingToken"
            value={ numberToWordsIndian(`${formData.dealAmount}`)}
            
            className="border rounded p-2 mb-3"
            required
          />
        </div>
        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
            Any final Discount for Customer in Deal done Amount
          </label>
          <input
            type="number"
            name="anyFinalDiscountFromDealAmount"
            value={formData.anyFinalDiscountFromDealAmount}
            onChange={handleChange}
            className="border rounded p-2 mb-3"
            required
          />
        </div>
        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
             Final Discount in Deal Amount done <strong> in Words</strong>
          </label>
          <input
            type="text"
            name="totalAmountGotTillNowExcludingToken"
            value={ numberToWordsIndian(`${formData.anyFinalDiscountFromDealAmount}`)}
            
            className="border rounded p-2 mb-3"
            required
          />
        </div>
        <div className="flex flex-col">
        
          <label className="text-gray-700 font-medium mb-2">
            Total Amount Received <strong className="font-bold text-black">Including</strong> Token
          </label>
          <input
            type="number"
            name="totalAmountGotFromCustomerTillNowIncludingToken"
            value={Number(formData.totalAmountGotTillNowExcludingToken) + Number(formData.tokenAmount)}
            onChange={handleChange}
            className="border rounded p-2 mb-3"
            required
          />
        </div>
        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
            Total Amount Including Token <strong>in Words</strong> 
          </label>
          <input
            type="text"
            name="totalAmountGotTillNowExcludingToken"
            value={ numberToWordsIndian(`${Number(formData.totalAmountGotTillNowExcludingToken) + Number(formData.tokenAmount)}`)}
            
            className="border rounded p-2 mb-3"
            required
          />
        </div>
        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
           Amount Come from Loan
          </label>
          <input
            type="number"
            name="amountComeFromLoan"
            value={formData.amountComeFromLoan}
            onChange={handleChange}
            className="border rounded p-2 mb-3"
            required
          />
        </div>
        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
             Amount Come from Loan  <strong>in Words</strong>
          </label>
          <input
            type="text"
            name="totalAmountGotTillNowExcludingToken"
            value={ numberToWordsIndian(`${formData.amountComeFromLoan}`)}
            
            className="border rounded p-2 mb-3"
            required
          />
        </div>
        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-3">
            LOAN AMOUNT STATUS
          </label>
          <select
            name="loanamountstatus"
            value={formData.loanamountstatus}
            onChange={handleChange}
            className="border rounded p-2 bg-white mb-3"
            required
          >
            <option value="Paid">Received in Bank</option>
            <option value="Not Paid">Currently Not Recieved in Bank</option>
            <option value="Not Applicable">Not Applicable</option>
            
            
            
          </select>
        </div>

        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
           Hold from Customer (<strong>RTO CHARGES CHHODH KE</strong>)
          </label>
          <input
            type="number"
            name="holdFromCustomer"
            value={Number(formData.dealAmount)-Number(formData.anyFinalDiscountFromDealAmount)-Number(formData.amountComeFromLoan)-Number(formData.totalAmountGotTillNowExcludingToken) - Number(formData.tokenAmount)}
            onChange={handleChange}
            className="border rounded p-2 mb-3"
            required
          />
        </div>
        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
           RTO Charge
          </label>
          <input
            type="number"
            name="RtoCharge"
            value={formData.RtoCharge}
            onChange={handleChange}
            className="border rounded p-2 mb-3"
            required
          />
        </div>
        </div>
     
        
<div className="relative w-full p-4 border border-blue-700 rounded" >
<div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
           Car Title
          </label>
          <input
            type="text"
            name="carTitle"
            value={formData.carTitle}
            onChange={handleChange}
            className="border rounded p-2 mb-3"
            required
          />
        </div>

        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
           Car Registration Number
          </label>
          <input
            type="text"
            name="carRegistrationNumber"
            value={formData.carRegistrationNumber}
            onChange={handleChange}
            className="border rounded p-2 mb-3"
            required
          />
        </div>


        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
           Customer whatsapp Number
          </label>
          <input
            type="number"
            name="customerWhatsappNumber"
            value={formData.customerWhatsappNumber}
            onChange={handleChange}
            className="border rounded p-2 mb-3"
            required
          />
        </div>

        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
           Customer Mobile Number
          </label>
          <input
            type="number"
            name="customerMobileNumber"
            value={formData.customerMobileNumber}
            onChange={handleChange}
            className="border rounded p-2 mb-3"
            required
          />
        </div>
        <div className="mb-4">
        <label className="block text-gray-700">Customer Email</label>
        <input
          type="email"
          name="customerEmail"
          value={formData.customerEmail}
          onChange={handleChange}
          className="w-full p-2 border border-gray-300 rounded mt-2"
          required
        />
      </div>
        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
           Customer Name <strong>(As Per Aadhaar)</strong>
          </label>
          <input
            type="text"
            name="customerName"
            value={formData.customerName}
            onChange={handleChange}
            className="border rounded p-2 mb-3"
            required
          />
        </div>


        <div className="flex flex-col">
          <label className="text-gray-700 font-medium mb-2">
           Customer Address
          </label>
          <input
            type="text"
            name="customerAddress"
            value={formData.customerAddress}
            onChange={handleChange}
            className="border rounded p-2 mb-3"
            required
          />
        </div>
</div>
        








      </div>

      <div className="text-center">
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          {loading ? (
          <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-50 z-50">
            {/* Spinner and Text Container */}
            <div className="flex flex-col items-center">
              {/* Outer Circle with Gradient */}
              <div className="relative w-28 h-28 mb-4">
                <div className="absolute w-full h-full border-4 border-t-transparent border-b-transparent border-l-blue-500 border-r-blue-300 rounded-full animate-spin"></div>

                {/* Inner Circle */}
                <div className="absolute top-2 left-2 w-24 h-24 bg-white rounded-full shadow-md flex items-center justify-center">
                  {/* Logo with Flip Animation */}
                  <img
                    src="https://res.cloudinary.com/dztz5ltuq/image/upload/v1731448689/apple-touch-icon_jrhfll.png" // Replace with your car logo path
                    alt="Car Logo"
                    className="w-12 h-12 animate-flip"
                  />
                </div>
              </div>

              {/* Text Below the Spinner */}
              <p className="text-xl md:text-2xl font-bold text-gray-800 text-center">
                <strong>Deal FORM IS SUBMITTING.... PLEASE WAIT </strong>
              </p>
            </div>
          </div>
        ) : (
          'Submit Deal Form'
        )}
        </button>
        
      </div>
    </form>
    {submissionSuccess && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md text-center">
            <h2 className="text-xl font-semibold text-green-600">Deal Form Submitted Successfully!</h2>
            <p className="mt-2 text-gray-700">THANK YOU.</p>
            <button
              onClick={() => setSubmissionSuccess(false)}
              className="mt-4 px-6 py-2 bg-blue-500 text
              white rounded-lg hover:bg-blue-600 transition"
            >
              Close
            </button>
          </div>
        </div>
      )}
  </div></div>
  );
};

export default  withAuthorization(SellDealForm, ["admin", "Employee"]);
